import React from 'react';

const AssignTaskStepCategory = React.lazy(() => import('pages/AssignTaskStep/AssignTaskStepCategory'));
const AssignTaskStepCategoryAdd = React.lazy(() => import('pages/AssignTaskStep/AssignTaskStepCategoryAdd'));
const AssignTaskStepCategoryEdit = React.lazy(() => import('pages/AssignTaskStep/AssignTaskStepCategoryEdit'));
const AssignTaskStepCategoryDetail = React.lazy(() => import('pages/AssignTaskStep/AssignTaskStepCategoryDetail'));

const assignTaskStepRoutes = [
  {
    path: '/assign-task-step-category',
    exact: true,
    name: 'Danh sách bước',
    function: 'ASSIGN_TASK_STEP_VIEW',
    component: AssignTaskStepCategory,
  },
  {
    path: '/assign-task-step-category/add',
    exact: true,
    name: 'Thêm mới bước',
    function: 'ASSIGN_TASK_STEP_ADD',
    component: AssignTaskStepCategoryAdd,
  },
  {
    path: '/assign-task-step-category/detail/:id',
    exact: true,
    name: 'Chi tiết bước',
    function: 'ASSIGN_TASK_STEP_VIEW',
    component: AssignTaskStepCategoryEdit,
  },
  {
    path: '/assign-task-step-category/edit/:id',
    exact: true,
    name: 'Chỉnh sửa bước',
    function: 'ASSIGN_TASK_STEP_EDIT',
    component: AssignTaskStepCategoryDetail,
  },
];

export default assignTaskStepRoutes;
